const Plus = ({ size = 5 }: { size?: number }): JSX.Element => {
  return (
    <i className={`bi bi-plus fs-${size}`} style={{ color: "blueviolet" }} />
  );
};

export default Plus;
